var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-question w-100 d-flex flex-column align-items-center justfiy-content-center text-center"},[_c('h3',{staticClass:"body-1 mb-5"},[_vm._v(_vm._s(_vm.question.question))]),_c('v-textarea',{attrs:{"outlined":"","v-model":_vm.currentAnswer?.answer,"placeholder":_vm.question.placeholder},on:{"input":_vm.handleInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }